import AsyncStorage from "@react-native-async-storage/async-storage";

// A team invite someone opened while signed out (components/screens/TeamInvite.js):
// kept for an hour so the app can bring them back to it after they sign in
// or create their account, wherever sign-in leaves them.

export const PENDING_INVITE_KEY = "eventlive.pendingTeamInvite";
const MAX_AGE_MS = 60 * 60 * 1000;

// The token format: <inviteId>.<secret>, both base64url.
export const isInviteToken = (token) =>
  typeof token === "string" &&
  /^[A-Za-z0-9_-]{8,64}\.[A-Za-z0-9_-]{8,128}$/.test(token);

export async function storePendingInvite(token, now = Date.now()) {
  if (!isInviteToken(token)) return false;
  try {
    await AsyncStorage.setItem(
      PENDING_INVITE_KEY,
      JSON.stringify({ token, at: now })
    );
    return true;
  } catch {
    return false;
  }
}

export async function readPendingInvite(now = Date.now()) {
  let raw = null;
  try {
    raw = await AsyncStorage.getItem(PENDING_INVITE_KEY);
  } catch {
    return null;
  }
  if (!raw) return null;
  try {
    const value = JSON.parse(raw);
    if (isInviteToken(value?.token) && now - Number(value.at) < MAX_AGE_MS) {
      return { token: value.token, at: Number(value.at) };
    }
  } catch {
    // Not ours: forget it below.
  }
  await clearPendingInvite();
  return null;
}

export async function clearPendingInvite() {
  try {
    await AsyncStorage.removeItem(PENDING_INVITE_KEY);
  } catch {
    // Storage unavailable: nothing was kept.
  }
}
